import { useAppStatus } from "@/hooks/use-banner-data";

import { Banner } from "./banner";

export function StagingBanner() {
  const { showBanner } = useAppStatus();

  if (!showBanner) return null;

  return <Banner message="Staging Environment" className="z-50" />;
}
